import {JSX, useState, useEffect} from 'react';
import WindowBar from '../../common/windowBar/windowBar';
import tvIcon from '../../assets/images/svgs/tv.svg';
import './weather.css';
import WeatherDataManager, { WeatherData } from './weatherManager';
import BmoFace, { WeatherType } from './bmo-face';
import bmo1 from '../../assets/images/bmo-face/Rosto-01.png';
import bmo2 from '../../assets/images/bmo-face/Rosto-02.png';
import bmo3 from '../../assets/images/bmo-face/Rosto-03.png';
import bmo4 from '../../assets/images/bmo-face/Rosto-04.png';
import bmo5 from '../../assets/images/bmo-face/Rosto-05.png';

const Weather = () : JSX.Element => {

    const [images, setImages] = useState<string[]>([bmo1, bmo2, bmo3, bmo4]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [weather, setWeather] = useState<WeatherData>();

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex(prev => (prev + 1) % images.length);
        }, 1000);
        
        return () => clearInterval(interval);
    }, []);
    
    const weatherManager = WeatherDataManager.getInstance();

    useEffect(() => {
        const fetchData = async () => {
            try {
                await weatherManager.fetchWeather('New Taipei');
                setWeather(weatherManager.getWeather());
            } catch (error) {
                console.error('Failed to fetch weather:', error);
            }
        };
    
        fetchData();

        const interval = setInterval(fetchData, 20000);
        return () => clearInterval(interval);
    }, []);

    const bmoFace = BmoFace.getInstance();

    useEffect(() => {
        console.log(weather?.shortDescription)
        setImages(bmoFace.getWeather(weather?.shortDescription as WeatherType));
    },[weather])

    return(
        <div className='outter-container weather-container'>
            <div className='pixel-container-back'/>
            <div className='pixel-container-top'>
                <div className='pixel-container-border'>
                    <WindowBar IconSrc={tvIcon} title={`${weather?.shortDescription}•ﻌ•`} onClick={()=>{}}/>
                    <div className='main-pixel-container main-face-container' >
                        <img className='bmo-face-img' src={images[currentIndex]}/>
                    </div>
                    <div className='main-pixel-container' >
                        <p className='bmo-weather-text'>{`temp: ${weather?.temp}    humidity: ${weather?.humidity}`}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Weather;